import React from 'react';

const isIso2 = code => typeof code === 'string' && code.length === 2;

const ImpactedCountries = ({ geoLocations }) => {
    let geoList = [];

    let geos = [];

    for (let country_code in geoLocations) {
        const validCountry = isIso2(country_code);

        let geo_location = geoLocations[country_code];
        geos.push({ ...geo_location, code: country_code, validCountry });
    }

    for (let geo_location of geos.sort((a, b) =>
        a.percent < b.percent ? 1 : -1
    )) {
        let percentage = parseInt(geo_location.percent * 100),
            listItem = (
                <li
                    key={geo_location.code}
                    style={{
                        textTransform: 'none',
                        fontWeight: 'normal',
                        color: '#797d82',
                    }}
                >
                    <span
                        className={
                            geo_location.validCountry
                                ? `flag-icon flag-icon-${geo_location.code?.toLowerCase()}`
                                : 'flag-icon'
                        }
                    />
                    {geo_location.validCountry
                        ? geo_location.name
                        : 'Unable to be Determined'}{' '}
                    {percentage >= 1 ? percentage : '< 1'}%
                </li>
            );
        geoList.push(listItem);
    }

    return (
        <div style={{ marginLeft: '10px' }}>
            <ul className="list-unstyled">{geoList}</ul>
        </div>
    );
};

export default ImpactedCountries;
